import { useMemo } from "react";
import { Package } from "lucide-react";
import { FulfillmentTypeEnum } from "@snackpass/snackpass-types";
import { t } from "@lingui/core/macro";

import { useOrders } from "../../orders-context";
import { FilterSelect2 } from "src/@/components/ui/filter-select-2";

export const OrdersFulfillmentPicker = () => {
    const { fulfillments, setFulfillments } = useOrders();

    const FULFILLMENT_TYPES = [
        { label: t`Pickup`, value: FulfillmentTypeEnum.Pickup },
        { label: t`Delivery`, value: FulfillmentTypeEnum.Delivery },
        { label: t`Dine In`, value: FulfillmentTypeEnum.DineIn },
    ];

    const selectedTypes = useMemo(
        () => new Set(fulfillments as string[]),
        [fulfillments],
    );

    return (
        <FilterSelect2
            title={t`Fulfillment`}
            icon={Package}
            selectedValues={selectedTypes}
            options={FULFILLMENT_TYPES}
            onOptionSelected={function (value: string): void {
                if (selectedTypes.has(value)) {
                    selectedTypes.delete(value);
                } else {
                    selectedTypes.add(value);
                }
                setFulfillments(
                    Array.from(selectedTypes) as FulfillmentTypeEnum[],
                );
            }}
        />
    );
};
